import { Badge, Button, Col, Modal, ProgressBar, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileInvoice,
  faFileInvoiceDollar,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState } from "react";
import { useAuth } from "../../providers/authprovider";
import { v4 as uuidv4 } from "uuid";
import {
  getProgressTitle,
  progress,
  getEventHeader,
  getInspectionFrequencyName,
  isInspection,
} from "./Event";
import useAlert from "../../components/CustomAlert";
import { useParams } from "react-router-dom";
import { getUserInitials } from "../../utils/utils";
import { useData } from "./Calendar";
import StatusModal, { STATE_DENIED } from "./StatusModal";
import { AddressDisplay } from "../../components/AddressForm";
import ProtocolsModal from "./ProtocolsModal";
import AddEditEventModal from "./AddEditEventModal";
import Notes from "../buildings/Notes";
import NotesModal from "./NotesModal";
import SearchBuildingEventsBar from "./SearchBuildingEventsBar";

export default function SearchEvents(props) {
  const { privilege } = props;
  const { shortBuildings } = useData();
  const { alert, showAlert } = useAlert();
  const [events, setEvents] = useState(undefined);
  const {
    calendar: { getBuildingEvents },
  } = useAuth();
  const { buildingId } = useParams();
  const [showBuildingHistory, setShowBuildingHistory] = useState(false);

  useEffect(() => {
    setEvents(undefined);

    getBuildingEvents(buildingId, ({ success, error, content }) => {
      if (success)
        return setEvents(
          content
            .sort((a, b) => Date.parse(a.date) - Date.parse(b.date))
            .sort((a, b) => {
              if (a.state === "FINISHED" && b.state === "FINISHED") return 0;
              if (a.state === "FINISHED") return 1;
              if (b.state === "FINISHED") return -1;
              return 0;
            }),
        );

      showAlert(error);
    });
  }, [buildingId]);

  const building = shortBuildings.find(
    (sb) => String(sb.id) === String(buildingId),
  );
  const address = building ? <AddressDisplay address={building} /> : null;
  const buildingName = building?.name || "";

  const handleSuccesfullEdit = (event) => {
    setEvents((prevState) => {
      const index = prevState.findIndex((e) => e.id === event.id);

      if (index < 0) return prevState;

      prevState.splice(index, 1, event);
      return [...prevState];
    });
  };

  const handleDeleteEvent = (eventToDelete) => {
    setEvents((prevState) => {
      if (!prevState) return prevState;
      return prevState.filter((e) => e.id !== eventToDelete.id);
    });
  };

  const handleShowBuildingHistory = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setShowBuildingHistory(true);
  };

  return (
    <>
      {alert()}
      {showBuildingHistory && (
        <Notes building={building} onHide={() => setShowBuildingHistory(false)} />
      )}
      <div className={"container"}>
        <div className={"ms-auto"} style={{ maxWidth: "420px" }}>
          <SearchBuildingEventsBar opened={true} />
        </div>
        <h3
          className={"eventNameLine cursor-pointer"}
          title={`Pokaz historię dla ${buildingName}`}
          onClick={handleShowBuildingHistory}
        >
          <u>{buildingName}</u>
        </h3>
        <h5>{address}</h5>
        {events?.map((event, lp) => {
          return (
            <div key={lp}>
              <big>{lp + 1}.</big>
              <Event
                key={uuidv4()}
                event={event}
                privilege={privilege}
                onEdit={handleSuccesfullEdit}
                onDelete={handleDeleteEvent}
              />
            </div>
          );
        })}
      </div>
    </>
  );
}

function Event(props) {
  const { event, privilege, onEdit, onDelete } = props;
  const { workers, shortBuildings, teams } = useData();
  const {
    user,
    calendar: { remove },
  } = useAuth();

  const [expanded, setExpanded] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [protocolsModal, setShowProtocolsModal] = useState(false);
  const [notesModal, setShowNotesModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const users = event.users
    ? workers.filter((w) => event.users.includes(w.id))
    : [];
  const variant = event.state === STATE_DENIED ? "danger" : "success";
  const animated = event.state === STATE_DENIED;
  const stateDenied =
    event.state === STATE_DENIED ? (
      <Badge bg="danger" className={"mb-1"}>
        <FontAwesomeIcon icon={faTriangleExclamation} /> Odrzucono termin
      </Badge>
    ) : (
      ""
    );

  const dateStart = new Date(event.date).toLocaleDateString();

  const handleSuccessAddEdit = (editedEvent) => {
    onEdit(editedEvent);
  };

  const handleDeleteEvent = () => {
    remove(event.id, ({ success }) => {
      if (success === true) {
        onDelete?.(event);
      }
      setShowDeleteModal(false);
    });
  };

  return (
    <div
      className={"border-1 border p-1 m-2 cursor-pointer"}
      onClick={() => setExpanded(true)}
    >
      <h5>{event.inspectionName}</h5>
      <div className={"d-inline-block float-end"}>
        {event.offers !== undefined && event.offers.length > 0 ? (
          <FontAwesomeIcon
            className={"fs-3 m-2 text-info "}
            icon={faFileInvoice}
            title={"Oferta"}
          />
        ) : null}
        {event.fvat ? (
          <FontAwesomeIcon
            className={"fs-3 m-2 text-muted"}
            icon={faFileInvoiceDollar}
            title={event.fvat_description}
          />
        ) : null}
      </div>
      {getEventHeader(event)}
      <Row>
        <Col lg={1}>{dateStart}</Col>
        <Col className={"p-2"}>
          {users?.map((userItem) => (
            <span
              key={userItem.id}
              className={"userBadge"}
              style={{ backgroundColor: userItem.color }}
              title={userItem.name}
            >
              {expanded ? userItem.name : getUserInitials(userItem)}
            </span>
          ))}
          {isInspection(event) && (
            <div className={"w-100 text-end pe-2"}>
              <small>
                <small>
                  <b>{getInspectionFrequencyName(event.frequency)}</b>
                </small>
              </small>
            </div>
          )}
          {stateDenied}
          {expanded && <div className={"fst-italic text-muted"}>{event.info}</div>}
        </Col>
      </Row>
      <ProgressBar
        animated={animated}
        now={progress(event)}
        variant={variant}
        title={getProgressTitle(event)}
        className={"statusProgressBar"}
      />

      {expanded && (
        <>
          <hr />
          <div className={"d-flex justify-content-end gap-1"}>
            <Button variant={"outline-success"} onClick={() => setShowEditModal(true)}>
              Edycja
            </Button>
            <Button variant={"outline-primary"} onClick={() => setShowStatusModal(true)}>
              Status
            </Button>
            <Button
              variant={"outline-secondary"}
              onClick={() => setShowProtocolsModal(true)}
            >
              Protokoły
            </Button>
            <Button variant={"outline-secondary"} onClick={() => setShowNotesModal(true)}>
              Notatki
            </Button>
            {user?.isAdmin && (
              <Button
                variant={"outline-danger"}
                onClick={() => setShowDeleteModal(true)}
              >
                Usuń
              </Button>
            )}
          </div>
        </>
      )}

      {showStatusModal && (
        <StatusModal
          show={true}
          event={event}
          onHide={() => setShowStatusModal(false)}
          onChangeEvent={handleSuccessAddEdit}
        />
      )}
      {protocolsModal && (
        <ProtocolsModal
          show={protocolsModal}
          event={event}
          onHide={() => setShowProtocolsModal(false)}
        />
      )}
      {showEditModal && (
        <AddEditEventModal
          privilege={privilege}
          show={true}
          event={event}
          onHide={() => setShowEditModal(false)}
          onSuccess={handleSuccessAddEdit}
          buildings={shortBuildings}
          teams={teams}
          workers={workers}
          date={event.date}
        />
      )}
      {notesModal && (
        <NotesModal
          show={notesModal}
          event={event}
          onHide={() => setShowNotesModal(false)}
        />
      )}

      {showDeleteModal && (
        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Potwierdź usunięcie</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Czy na pewno chcesz usunąć to wydarzenie z kalendarza?
            <div className="mt-2 text-muted">
              <div>
                <b>Nazwa:</b> {event.inspectionName || "-"}
              </div>
              <div>
                <b>Data:</b> {dateStart}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
              Anuluj
            </Button>
            <Button variant="danger" onClick={handleDeleteEvent}>
              Usuń
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
}
